import React from 'react';
import { useInventoryTransferQuery } from '../../../../../hooks/inventory/useInventoryTransferQuery';
import FormModal from '../../../../Modals/FormModal';
import TransferInfoSection from './Sections/TransferInfoSection';
import TransferBranchesSection from './Sections/TransferBranchesSection';
import TransferFlowSection from './Sections/TransferFlowSection';
import AuditSection from './Sections/AuditSection';

const InventoryTransferDetailModal: React.FC = () => {
  const { detailTransfer, showDetailTransferModal, handlerCloseDetailModal } =
    useInventoryTransferQuery();

  if (!detailTransfer) return null;

  return (
    <FormModal
      isOpen={showDetailTransferModal}
      onClose={handlerCloseDetailModal}
      title="Detalle del Traslado"
      maxWidth="max-w-4xl"
      zIndex='front'
    >
      <div className="space-y-8 px-2 py-4">
        <TransferInfoSection
          details={detailTransfer.details}
          reason={detailTransfer.reason}
          status={detailTransfer.status}
        />

        <TransferBranchesSection
          origin={detailTransfer.originBranchName}
          destination={detailTransfer.destinationBranchName}
        />

        <TransferFlowSection detail={detailTransfer} />

        <AuditSection detail={detailTransfer} />
      </div>

      {/* -------------------------------------------------------- */}
      {/* Botón Cerrar */}
      {/* -------------------------------------------------------- */}
      <div className="mt-6 flex justify-end">
        <button
          type="button"
          onClick={handlerCloseDetailModal}
          className="rounded bg-primary px-6 py-2 font-semibold text-white hover:bg-opacity-90"
        >
          Cerrar
        </button>
      </div>
    </FormModal>
  );
};

export default InventoryTransferDetailModal;
